package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
class GetStripeAccountStatusResponseModel(
    // PaymentProvider.code of the merchant ("mypos" | "stripe")
    val paymentProvider: String = "mypos",
    val hasStripeAccount: Boolean = false,
    val detailsSubmitted: Boolean = false,
    val chargesEnabled: Boolean = false,
    val payoutsEnabled: Boolean = false
) : BaseResponseModel()
